import { Box, CircularProgress, useTheme } from "@mui/material";
import type { JSX } from "react";

interface LoadingOverlayProps {
  open: boolean;
  size?: number;
}

export const LoadingOverlay = ({ open, size = 48 }: LoadingOverlayProps): JSX.Element | null => {
  const theme = useTheme();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: theme.zIndex.modal,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
